module.exports = __webpack_public_path__ + "static/media/bonus_level_5.a21116f4.png";